import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import Printd from 'printd'
import moment from 'moment'
import Loader from './../shared/loader'

export default {
  name: 'sourceSTNreport',
  components: {
    Paginate,
    DatePicker,
    Loader
  },
  data: function() {
    return {
      currentPage: 0,
      totalRows:0,
      showSTNModel: false,
      viewSTNmodal: false,
      checkStockmodel: false,

      listClientData: [],
      listSTNData: [],
      listFCData: [],
      liststatusData: [{
        'status': 'created'
      }, {
        'status': 'confirmed'
      }, {
        'status': 'rackout'
      }],

      STNDetails: [],
      sourceWarehouseDetails: [],
      destinationWarehouseDetails: [],
      warehousedata: [],
      stnidDetails: [],
      Details: [],
      pageno: 0,
      pageCount: 0,
      pageLimit: 10,

      status: '',

      client: '',
      isfound: '',
      warehouse: '',
      clientid: '',
      warehouseid:'',
      showSelectClient: false,
      showSelectWarehouse: false,
      user_type: '',
      ClientErr: '',
      WarehouseErr: '',

      searchType: '1',
      searchSTNID: '',
      searchclient: '',
      searchFC: '',
      searchcreationdate: '',
      resultCount: '',
      isLoading: false,
      loading: false,
      loadingText: '<i class="fa fa-spinner fa-spin"></i> Loading...',

    }
  },
  //display date in DD-MM-YYYY format
  filters: {
    moment: function(date) {
      return moment(date).format('DD-MM-YYYY');
    }
  },
  created: function() {},
  computed: {
    //display table rows
    STNsubtotal: function() {
      let subtotal = [];

      Object.entries(this.STNDetails).forEach(([key, val]) => {
        subtotal.push(val.subtotal) // the value of the current key.
      });
      return subtotal.reduce(function(subtotal, num) {
        return Number(subtotal) + Number(num)
      }, 0);
    },

    //disables table rows when clientname and sourcewarehouse are absent
  },
  // when a page loads,mounted() will be call
  mounted() {

    var permissionEncrypt = window.localStorage.getItem('userdetail');
    var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.createdbyuserid = userdetail.userid;
    this.isLoading = false;
    this.pageno = 0;
    this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client

    //this.getClientList();
    this.user_type = userdetail.utype;
    switch (this.user_type) {
      case 'system_user':
        this.showSelectClient = true;
        this.showSelectWarehouse = true;
        // this.getClientList();
        //this.getWarehouseList();
        break;

      case 'client_user':
        this.clientid = userdetail.clientid;
        this.client = this.clientid;
        // this.getWarehouseList();
        this.showSelectWarehouse = true;
        break;

      case 'warehouse_user':
        this.showSelectClient = true;
        this.loginUserEmail = userdetail.email;
        this.userwarehouse = userdetail.warehouseid;
        this.warehouse = userdetail.warehouseid;
        this.searchFC = this.warehouse;

        // this.getClientList();

        var roleids = userdetail.roleid.split(',');
        for (var i = 0; i < roleids.length; i++) {
          if (roleids[i] == 40) {
            this.purchasingManager = parseInt(roleids[i]);
          }
          if (roleids[i] == 41) {
            this.isInwardUserForPO = true;
          }
        }
        break;

      default:
        this.$alertify.error(this.$t('common.unauthorisedError') + "Unauthorised user, Please contact your system admin");
        break
    }
  },
  methods: {
    // clientSelected() {

    //   if (this.client != this.searchclient) {
    //     this.client = this.searchclient;
    //     this.listFCData = [];
    //     this.listDestinationFCData = [];
    //   } else
    //     this.client = this.searchclient;

    //   if (this.user_type != 'warehouse_user')
    //     this.getWarehouseList();
    //   this.getSTNData();

    // },

    // warehouseSelected() {
    //   this.warehouse = this.searchFC;
    //   if (this.warehouse) {
    //     if (this.client) {
    //       this.getSTNData();
    //     } else {
    //       this.getClientList();
    //     }
    //   }
    // },
    // getClientList() {
    //   this.pageno = 0;
    //   if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

    //   var userToken = window.localStorage.getItem('userToken');
    //   var myStr = userToken.replace(/"/g, '');

    //   this.input = ({
    //     warehouseid: this.warehouse,
    //   });

    //   axios({
    //       method: 'POST',
    //       'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
    //       'data': this.input,
    //       headers: {
    //         'Authorization': 'Bearer ' + myStr,
    //       }
    //     })
    //     .then(result => {
    //       this.listClientData = result.data.data;
    //     }, error => {
    //       console.error(error);
    //     });
    //   }
    // },
    // getWarehouseList() {
    //   this.pageno = 0;

    //   if (window.localStorage.getItem("warehouseList") !== null) {
    //     var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
    //     var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
    //     var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
    //     this.listFCData = JSON.parse(plaintextwarehouse);
    //   } else {

    //   var userToken = window.localStorage.getItem('userToken')
    //   var myStr = userToken.replace(/"/g, '');

    //   this.input = ({
    //     clientid: this.client,
    //   });

    //   axios({
    //       method: 'POST',
    //       'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
    //       'data': this.input,
    //       headers: {
    //         'Authorization': 'Bearer ' + myStr
    //       }
    //     })
    //     .then(result => {
    //       //this.listWarehouseData = result.data.data;
    //       this.listFCData = result.data.data;
    //     }, error => {
    //       console.error(error)
    //     })
    //   }
    // },
    print() {
      const d = new Printd();
      var buffer = '';
      this.loading = true;
      var cssText = `
		   body{
		  			-webkit-print-color-adjust:exact;
					}
		   table {
		       border-collapse: collapse;
		       margin-left:0px !important;
		   }
		   table, td, th {
		     border-style: solid;
				 border-width: 1px;
				 margin-bottom: 10px;
				 border-color: rgba(0,0,255,0.25);
		     padding:5px;
		   }
			 pre {
			   color: #c7254e;
			 }
			 .text-right{
			   text-align:right;
			 }
			 .clientdetails{
			   margin-top:-40px;
			   font-size:12px;
			 }
			 .printbtn{
				 display:none;
			 }
			 .downarr{
				 float:right;
			 }
			 .forprint{
				 display:block;
			 }
			 .displayprint{
				 display:none;
			 }
			 @media print {
			 .text-primary th{
			   background-color:rgb(226, 216, 216) !important;
			   color:black !important;
			   font-size:20px !important;
			 }
			 .totalval{
				 float:left;
				 height:30px;
				 width:48%;
				 margin-left:10px;
			 }
			 .makebold{
				 font-weight:800;
				 font-weight: bold;
			 }
			}`

      d.print(document.getElementById('STNContent'), cssText);
      this.loading = false;
    },
    dateFormat(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD');
    },
    //open new form(popup)
    twoDecimal(val) {
      return val.toFixed(2);
    },

    findObjectByKey(array, key, value) {
      for (var j = 0; j < array.length; j++) {
        if (array[j][key] == value) {
          return array[j];
        }
      }
      return null;
    },

    //to get Product Details
    getSTNRowDetails(data, client) {
      this.showSTNModel = true;
      this.viewSTNmodal = true;
      this.stnid = data.stnid;
      this.getSTNDetails(data, client)
      this.$validator.reset();
      this.errors.clear();
    },
    //to close add (new) form
    closeviewSTNmodal() {
      this.viewSTNmodal = false
    },
    //to get STN list
    getSTNDetails(data, client) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.pageno = 0
      this.input = ({
        'stnid': data,
        "clientid": client 
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getSingleSTNDetails',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.STNDetails = result.data.data.data[1].details;
          this.stnidDetails = result.data.data.data[1].details[0].stnid;

          this.Details = result.data.data.data[0][0];
          this.warehouseDetails = result.data.data.data[1].WarehouseDetails;

          var swarehouse = result.data.data.data[0][0].sourcewarehouse;
          var dwarehouse = result.data.data.data[0][0].destinationwarehouse;

          this.sourceWarehouseDetails = result.data.data.data[2].WarehouseDetails[swarehouse];
          this.destinationWarehouseDetails = result.data.data.data[2].WarehouseDetails[dwarehouse]
        }, error => {
          console.error(error)
        })
    },


    //to get STN list
    getSTNData() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      if (this.user_type == "client_user" && this.searchclient == '') {
        this.searchclient = this.clientid;
      }

      if (window.localStorage.getItem('selectedClient')==='undefined') {
        this.$alertify.error('Please Select Client')
        this.pageCount = 0;
        return false;
      }
      if (this.searchSTNID != '' && !(this.searchSTNID > 0)) {
        this.$alertify.error(this.$t('stockTransfer.stnIdError'));
        return false;
      }
      if (typeof this.searchcreationdate == 'undefined' || this.searchcreationdate == '')
        this.searchcreationdate = '';



      this.input = ({
        userwarehouse: this.userwarehouse,
        offset: this.pageno,
        limit: this.pageLimit,
        stnid: this.searchSTNID,
        clientid: this.clientid,
        status: this.status,
        creationdate: this.dateFormat(this.searchcreationdate),
      })

      if (this.searchType == '1')
        this.input.destinationwarehouseid = this.warehouse;
      else if (this.searchType == '2')
        this.input.sourcewarehouseid = this.warehouse;
        this.totalRows=0
      this.isLoading = true;
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getSTNlistForSource',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listSTNData = result.data.data;
          this.isLoading = false;
          this.totalRows = result.data.totalRows;
          this.resultCount = result.data.totalRows
          if (this.totalRows <= this.pageLimit) {
            this.pageCount = 1;
          } else {
            this.pageCount = Math.ceil(this.totalRows / this.pageLimit);
          }
          this.warehousedata = result.data.WarehouseDetails[0];
          var listClients = result.data.clintdata;
          for (var i = 0; i < this.listSTNData.length; i++) {
            var objindex = this.findObjectByKey(listClients, "clientid", this.listSTNData[i].clientid);
            //  let objindex = array.indexOf(objindex);
            this.listSTNData[i]['clientname'] = objindex.clientname;
            this.listSTNData[i]['sourcewarehousename'] = this.warehousedata[this.listSTNData[i].sourcewarehouse].warehousename;
            this.listSTNData[i]['destinationwarehousename'] = this.warehousedata[this.listSTNData[i].destinationwarehouse].warehousename;
          }
        }, error => {
          console.error(error)
        })
    },

    //update form fields

    getPaginationData(currentPage) {
      this.pageno = (currentPage - 1) * this.pageLimit
      this.getSTNData()
    },

    onSubmit: function() {
      this.$validator.validateAll().then(() => {
        console.log('form is valid')
      }).catch(() => {
        console.log('errors exist')
      });
    },

    //closes modal(View STN popup)
    hidecheckStockmodel() {
      this.checkStockmodel = false;
    },
    //opens modal(View STN popup)
    opencheckStockmodel() {
      this.checkStockmodel = true;
    },
    //to reset search form
    resetFormData() {
      this.searchSTNID = '';
      this.searchclient = '';
      this.searchFC = '';
      this.status = '';
      this.searchcreationdate = '';
      this.listSTNData = [];
      this.totalRows=0;
      this.searchType = '1'
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/sourceSTNreport/sourceSTNreport.component.js